import { ChevronRight } from '@mui/icons-material'
import NavLinkWithQuery from 'common/components/NavLinkWithQuery'

interface IDataViewBreadcrumb {
  dataManagementPath: string
  dataViewPath: string
  viewName: string
}

const DataViewBreadcrumb = ({
  dataManagementPath,
  dataViewPath,
  viewName
}: IDataViewBreadcrumb) => {
  return (
    <div className='flex items-center'>
      <NavLinkWithQuery
        to={dataManagementPath}
        className='text-sm font-medium text-lighthouseBlue'
      >
        Data Management
      </NavLinkWithQuery>
      <ChevronRight fontSize='small' className='mx-0.5 text-gray-300' />
      <NavLinkWithQuery
        to={dataViewPath}
        className='text-sm font-medium text-lighthouseBlue'
      >
        Data Views
      </NavLinkWithQuery>
      <ChevronRight fontSize='small' className='text-gray-300' />
      <div className='text-sm font-medium'>{viewName}</div>
    </div>
  )
}

export default DataViewBreadcrumb
